function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M26 12c0-6.089-4.172-10-10-10S6 5.911 6 12c0 4.193 3.315 10.068 10 17.512C22.685 22.068 26 16.192 26 12zM4 12C4 4.777 9.095 0 16 0s12 4.777 12 12c0 4.905-3.649 11.288-10.89 19.266a1.5 1.5 0 0 1-2.118.103c-.053-.05-.053-.05-.103-.103C7.65 23.288 4 16.906 4 12zm12 4a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
});

var SvgMap = function SvgMap(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "4caee5adaab17b0f24f494eae36859b2.svg";
export { SvgMap as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/map.svg
// module id = null
// module chunks = 